<div class="nav-menu mat-typography">
  @for (menu of siteNav().menus; track menu.id) {
    @if (!menu.searchOnly) {
      @if (menu.sections.length || menu.label === 'Agency Websites') {
        <button class="menu"
                [class.hide-xs]="menu.hideOnMobile"
                [title]="menu.label"
                (touchmove)="preventInteraction()"
                (touchend)="handleTouch(menu, $event)"
                (click)="handleNavClick(menu, $event)"
                (mouseenter)="openSideMenu(menu)"
                (mouseleave)="closeSideMenu($event)"
                [class.active]="openSideBar() && currentTab()?.label === menu.label"
                [id]="menu.id">
          <ng-container [ngTemplateOutlet]="menuIcon"
                        [ngTemplateOutletContext]="{ menu: menu }" />
        </button>
      } @else {
        @if (!menu.isRouterLink) {
          <a class="menu"
             [class.active]="openSideBar() && currentTab()?.label === menu.label"
             [class.hide-xs]="menu.hideOnMobile"
             [id]="menu.id"
             [title]="menu.label"
             [href]="menu.url"
             (mouseenter)="openSideMenu(menu)"
             (mouseleave)="closeSideMenu($event)"
             (click)="track(menu)"
             [target]="menu.targetNewWindow ? '_blank' : '_self'">
            <ng-container [ngTemplateOutlet]="menuIcon"
                          [ngTemplateOutletContext]="{ menu: menu }" />
          </a>
        } @else {
          <a class="menu"
             [class.active]="openSideBar() && currentTab()?.label === menu.label"
             [class.hide-xs]="menu.hideOnMobile"
             [id]="menu.id"
             [title]="menu.label"
             [href]="menu.url"
             (click)="interopRouterLink($event, menu)"
             (mouseenter)="openSideMenu(menu)"
             (mouseleave)="closeSideMenu($event)">
            <ng-container [ngTemplateOutlet]="menuIcon"
                          [ngTemplateOutletContext]="{ menu: menu }" />
          </a>
        }
      }
    }
  }
</div>
@if (openSideBar() && currentTab()?.sections.length) {
  <div class="menu-expanded mat-typography"
       (mouseleave)="closeSideMenu($event)">
    @for (section of currentTab().sections; track section.id) {
      <div [class.beta-highlight]="section.beta"
           class="menu-sub-item">
        <div class="row expanded-header">{{section.label}}
          @if (section.beta) {
            <ez-chip color="accent">Beta</ez-chip>
          }
          @if (section.label === 'Support') {
            <button id="chat-support"
                    mat-stroked-button
                    (click)="toggleSupport()"
                    title="Connect with Support">
              Chat
              <mat-icon>help</mat-icon>
            </button>
          }
        </div>
        <ul class="hide-xs">
          @for (item of section.menuItems; track item.id) {
            <li>
              @if (!item.searchOnly && item.url) {
                @if (!item.isRouterLink) {
                  <a [href]="item.url"
                     [target]="item.targetNewWindow ? '_blank' : '_self'"
                     [title]="item.label"
                     [attr.id]="item.name">
                    {{item.label}}
                    @if (item.newMenu) {
                      <ez-chip color="accent">New</ez-chip>
                    }
                  </a>
                } @else {
                  <a [href]="item.url"
                     (click)="interopRouterLink($event, item)"
                     [attr.id]="item.name"
                     [title]="item.label">
                    {{item.label}}
                    @if (item.newMenu) {
                      <ez-chip color="accent">New</ez-chip>
                    }
                  </a>
                }
              } @else {
                {{item.label}}
              }
            </li>
          }
        </ul>
        <mat-nav-list class="hide-gt-xs">
          @for (item of section.menuItems | slice: 0:sliceRecent(section); track item.id) {
            @if (!item.searchOnly && item.url) {
              @if (!item.isRouterLink) {
                <a mat-list-item
                   [href]="item.url"
                   [target]="item.targetNewWindow ? '_blank' : '_self'"
                   [title]="item.label"
                   [attr.id]="item.name"
                   [class.hide-xs]="item.hideOnMobile">
                  {{item.label}}
                  @if (item.newMenu) {
                    <ez-chip color="accent">New</ez-chip>
                  }
                </a>
              } @else {
                <a mat-list-item
                   [href]="item.url"
                   (click)="interopRouterLink($event, item)"
                   [title]="item.label"
                   [attr.id]="item.name"
                   [class.hide-xs]="item.hideOnMobile">
                  {{item.label}}
                  @if (item.newMenu) {
                    <ez-chip color="accent">New</ez-chip>
                  }
                </a>
              }
            } @else {
              <span mat-list-item>{{item.label}}</span>
            }
          }
        </mat-nav-list>
      </div>
    }
  </div>
}
<ng-template #menuIcon
             let-menu="menu">
  @if (menu.badge) {
    <mat-icon [svgIcon]="menu.useSVG ? menu.icon : ''"
              matBadge="!"
              matBadgeSize="small"
              matBadgeColor="accent">
      @if (!menu.useSVG) {
        {{menu.icon}}
      }
    </mat-icon>
  } @else {
    <mat-icon [svgIcon]="menu.useSVG ? menu.icon : ''">
      @if (!menu.useSVG) {
        {{menu.icon}}
      }
    </mat-icon>
  }
</ng-template>